"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MagnifyingGlassIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const MagnifyingGlassIcon = (_a) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ width: "25", height: "27", viewBox: "0 0 25 27", fill: color !== null && color !== void 0 ? color : theme.colors.grey90, xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("circle", { id: "Ellipse 209", cx: "9.88472", cy: "8.9657", r: "6.43765", transform: "rotate(-35 9.88472 8.9657)", stroke: color !== null && color !== void 0 ? color : theme.colors.grey90, strokeWidth: "2", fill: "none" }), (0, jsx_runtime_1.jsx)("path", { id: "Vector 261", d: "M18.7556 23.2241C19.0724 23.6765 19.6959 23.7864 20.1483 23.4697C20.6007 23.1529 20.7107 22.5293 20.3939 22.0769L18.7556 23.2241ZM13.0198 15.0326L18.7556 23.2241L20.3939 22.0769L14.6581 13.8854L13.0198 15.0326Z", fill: color !== null && color !== void 0 ? color : theme.colors.grey90 })] })));
};
exports.MagnifyingGlassIcon = MagnifyingGlassIcon;
//# sourceMappingURL=magnifying_glass_icon.js.map